export const mockedLDFlags = {
  'dmb.delaro-2022-trial-regions-visualization': {
    value: true,
  },
  'dmb.delaro-2022-experimental-units': {
    value: true,
  },
  'web.microsoft-weather': {
    value: false
  },
  'web.microsoft-imagery': {
    value: false
  },
  'web-dmb-frr-as-applied': {
    value: true
  },
  'web-dmb-frr-ui-enhancements': {
    value: false
  },
  'web.historical-weather-commercial-policy': {
    value: false
  },
  'web.microsoft-weather-gdd': {
    value: false
  },
  'web.dmb-sprout-migration': {
    value: false
  },
  'web.scouting-add-photo-commercial-policy': {
    value: false
  },
  'web.dmb-fv-spatial-display-product-packaging-asset': {
    value: false
  },
  'web.dmb-split-view-product-packaging-asset': {
    value: false
  },
  'dmb.hide-spatial-display-feature': {
    value: false
  },
  'web-dmb-enhanced-scouting': {
    value: false
  },
  'dmb.spray-assist-feature': {
    value: false
  },
  'dmb-std-yield': {
    value: false,
  },
  'dmb.application-card': {
    value: false,
  },
};
